module.exports = __webpack_public_path__ + "img/trustpilot-horizontal-upsell.8903fedc.png";